import React from 'react';
import { ZOHO_SALESIQ_WIDGET_SRC } from 'src/utils/constants';

declare global {
  interface Window {
    $zoho?: any;
  }
}

export const useZohoChat = (enabled: boolean) => {
  React.useEffect(() => {
    if (!enabled || document.getElementById('zsiqscript') != null) {
      return;
    }

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: () => {} };

    const script = document.createElement('script');
    script.id = 'zsiqscript';
    script.src = ZOHO_SALESIQ_WIDGET_SRC;
    script.defer = true;
    document.head.appendChild(script);
  }, [enabled]);
};
